import Vue from 'vue';
import VueRouter from 'vue-router';
import ListClientsView from '@/views/ListClientsView.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: ListClientsView
	},
	{
		path: '/add',
		name: 'Add',
		component: () => import(/* webpackChunkName: "client" */ '@/views/AddClientView.vue'),
	},
	{
		path: '/:clientId',
		name: 'Details',
		component: () => import(/* webpackChunkName: "client" */ '@/views/ClientView.vue'),
	},
	{
		path: '*',
		redirect: { name: 'Home' }
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
